const UserProfile = () => import('./components/UserProfile.vue');

export default [
    {
        path: '/users/profile',
        component: UserProfile,
        name: 'user-profile',
    }
];
